import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — class-name helper used by every shadcn primitive.
 * Combines clsx (conditional classes) with tailwind-merge (deduplicates conflicting Tailwind utilities).
 *
 * Usage:
 *   cn('px-4 py-2', condition && 'bg-primary', className)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
